import * as React from "react";
import type { SVGProps } from "react";
const SvgQuickjumpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="quickjump_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M764.587 282.453a42.667 42.667 0 0 0-23.04-23.04A42.667 42.667 0 0 0 725.333 256H298.667a42.667 42.667 0 0 0 0 85.333h323.84L268.373 695.04a42.667 42.667 0 0 0 13.867 69.93 42.667 42.667 0 0 0 46.72-9.343l353.707-354.134v323.84a42.667 42.667 0 0 0 85.333 0V298.667a42.539 42.539 0 0 0-3.413-16.214z"
    />
  </svg>
);
export default SvgQuickjumpIcon;
